import CountdownWidgetView from './CountdownWidgetView.vue';

export const type = 'countdown';
export const view = CountdownWidgetView;

export function builder() {
  return {
    type,
    left: 50,
    top: 50,
    rotate: 0,
    date: new Date('2025-11-14T00:00:00.000Z'),
  };
}
